import { Injectable } from "@angular/core";
import { IKeyValueStore } from "./key-value-store.interface";

@Injectable()
export class SqliteStore implements IKeyValueStore {
  private readonly cachePrefix = "native-kv:";

  async get<T>(key: string): Promise<T | null> {
    const rawValue = localStorage.getItem(this.cachePrefix + key);
    if (!rawValue) {
      return null;
    }

    try {
      return JSON.parse(rawValue) as T;
    } catch {
      return null;
    }
  }

  async set<T>(key: string, value: T): Promise<void> {
    localStorage.setItem(this.cachePrefix + key, JSON.stringify(value));
  }

  async remove(key: string): Promise<void> {
    localStorage.removeItem(this.cachePrefix + key);
  }

  async clear(): Promise<void> {
    const keysToDelete: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(this.cachePrefix)) {
        keysToDelete.push(key);
      }
    }

    keysToDelete.forEach((key) => localStorage.removeItem(key));
  }
}
